import React from "react";

export default class LogoRight extends React.Component {

    render() {
        return (
            <div className="logoItem flex row justify-center items-center">
                <style>{this.props.fontStyle}</style>
                <h3 style={this.props.textStyle} className={"logoText " + this.props.textClass}>{this.props.text}</h3>
                <img alt="Logo" src={this.props.logoUrl} width="100%" style={this.props.logoStyle}/>


            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/logos/logoRight.js